<template>
  <div>
    <a href="/"><img class="titleBanner" src="../assets/banner.png" /></a>
  </div>
</template>

<script>
export default {
  name: "Header",
};
</script>
<style scoped>
a {
  color: antiquewhite;
  text-decoration: none;
  font-size: xx-large;
}
.titleBanner {
  height: 150px;
}
.counter {
  color: aliceblue;
}
</style>
